import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Image } from '@hivebrite/design-system/Image';
import { primaryShadow } from '@hivebrite/design-system/Theme';

import { AttendeesRow } from 'hb-react/shared/apps/Events/components/AttendeesRow';

import type { Event } from './types';
import {
  Body,
  Calendar,
  Cancelled,
  Categories,
  Header,
  Location,
  OnlineEvent,
  Owner,
  PricingTag,
  Spacer,
  StartEndDates,
  Title,
} from './ui';

export const EventCard = ({
  event,
  onClick,
}: {
  event: Event;
  onClick?: (event: Event) => void;
}) => (
  <Card data-testid="event-card" onClick={() => onClick?.(event)}>
    <Header>
      {event.cancelled ? (
        <Cancelled event={event} />
      ) : (
        <PricingTag event={event} />
      )}

      <Image
        src={event.coverPicture}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />

      <Calendar startDate={event.startDate} />
    </Header>
    <Body>
      <Title>{event.title}</Title>

      <Owner event={event} />

      <Box flexDirection="column" gridRowGap={1}>
        <StartEndDates event={event} />
        <Location event={event} />
        <OnlineEvent event={event} />
      </Box>

      <Spacer />

      {event.hasAttendees && (
        <AttendeesRow
          event={{
            has_attendees: event.hasAttendees,
            id: event.id,
            type: event.type,
          }}
          mt={0}
          imgSize={32}
        />
      )}
      <Categories event={event} />
    </Body>
  </Card>
);

const Card = styled(Box)`
  ${primaryShadow}
  flex-direction: column;
  overflow: hidden;
  width: 326px;
  flex-grow: 1;

  background-color: ${({ theme }) => theme.colors.white};

  border-radius: ${({ theme }) => theme.space[2] + 2}px;
`;
